const signUpPageTranslations = {
  formTitle: "Transform your body now with",
  formTitleHook: "Informa",
  subtitle: "You are one click away from changing your life",
  form: {
    secretKey: "Enter Your Secret Key",
    firstName: "First name",
    lastName: "Last name",
    phoneNumber: "Phone number",
    username: "Username",
    email: "Email",
    password: "Password",
  },
  steps: {
    secretKey: "Secret Key",
    generalInfo: "General Info",
  },
  cta: {
    back: "Back",
    submit: "Submit",
    next: "Next",
  },
};

export default signUpPageTranslations;
